var exports = {
  "container": "xdbfd91f1--100de9--container",
  "title": "xdbfd91f1--100de9--title",
  "container-stocks": "xdbfd91f1--100de9--container-stocks",
  "container-stocks--open": "xdbfd91f1--100de9--container-stocks--open",
  "container-stocks--close": "xdbfd91f1--100de9--container-stocks--close",
  "toggle-btn": "xdbfd91f1--100de9--toggle-btn",
  "toggle-btn--open": "xdbfd91f1--100de9--toggle-btn--open",
  "content": "xdbfd91f1--100de9--content",
  "content--open": "xdbfd91f1--100de9--content--open",
  "content--close": "xdbfd91f1--100de9--content--close",
};

module.exports = exports;
